import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  // mode: 'history',
  // base: '/partner/',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'index',
      },
    },
    {
      path: '/index',
      name: 'index',
      component: () =>
        import(/* webpackChunkName: "index" */ '../views/index.vue'),
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () =>
        import(
          /* webpackChunkName: "userAgreement" */ '../views/userAgreement.vue'
        ),
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () =>
        import(
          /* webpackChunkName: "privacyPolicy" */ '../views/privacyPolicy.vue'
        ),
    },
    {
      path: '/writtenAuthorization',
      name: 'writtenAuthorization',
      component: () =>
        import(
          /* webpackChunkName: "writtenAuthorization" */ '../views/writtenAuthorization.vue'
        ),
    },
    {
      path: '/userService',
      name: 'userService',
      component: () =>
        import(
          /* webpackChunkName: "userService" */ '../views/userService.vue'
        ),
    },
    {
      path: '/paymentService',
      name: 'paymentService',
      component: () =>
        import(
          /* webpackChunkName: "paymentService" */ '../views/paymentService.vue'
        ),
    },
    {
      path: '/contractAgreement',
      name: 'contractAgreement',
      component: () =>
        import(
          /* webpackChunkName: "contractAgreement" */ '../views/contractAgreement.vue'
        ),
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: () =>
        import(/* webpackChunkName: "downloads" */ '../views/downloads.vue'),
    },
    {
      path: '/thirdSdkList',
      name: 'thirdSdkList',
      component: () =>
        import(
          /* webpackChunkName: "thirdSdkList" */ '../views/thirdSdkList.vue'
        ),
    },
    {
      path: '/sdkIllustration',
      name: 'sdkIllustration',
      component: () =>
        import(
          /* webpackChunkName: "thirdSdkList" */ '../views/sdkIllustration.vue'
        ),
    },
  ],
})

export default router
